import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postVisitedArticle } from 'app/services/suggestedArticle';

import useFetchHelpCenter from '../fetch/useFetchHelpCenter';

export default function usePostVisitedArticle() {
  const queryClient = useQueryClient();
  const { data: helpCenter } = useFetchHelpCenter();

  return useMutation({
    mutationFn: (payload: { articleId: string; withSuggestedArticle: boolean }) =>
      postVisitedArticle({
        uuid: helpCenter?.uuid || '',
        articleId: payload.articleId,
        withSuggestedArticle: payload.withSuggestedArticle,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['suggestedArticle'] });
    },
  });
}
